let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("tNJpX"), load("5wDx5"), load("3arc9"), load("48wTS")]).then(() => parcelRequire('6tI2Z'));